import { Modal } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { useDateTimeService } from 'framework/utils';
import { Typography } from '@mui/material';

type PreviousPayrollGenerationModalProps = {
  isOpened: boolean;
  isChanged: boolean;
  close: (res: boolean) => any;
  generationDate: string;
};
const PreviousPayrollGenerationModal = ({
  isOpened,
  isChanged,
  generationDate,
  close,
}: PreviousPayrollGenerationModalProps) => {
  const { formatDateWithFullFormat } = useDateTimeService();

  const yes = (
    <Button color="primary" key="disqualifyBtn" onClick={() => close(true)}>
      Yes
    </Button>
  );

  const no = (
    <Button color="secondary" key="disqualifyBtn" onClick={() => close(false)}>
      No
    </Button>
  );

  return (
    <Modal
      hasCancelButton={false}
      isOpen={isOpened}
      title={`The report data has${isChanged ? '' : ' not'} been changed`}
      onToggle={() => close(false)}
      buttons={[yes, no]}
    >
      <Typography variant="body1">
        The report data{' '}
        <Typography variant="subtitle1" component="span">
          has{isChanged ? '' : ' not'} been
        </Typography>{' '}
        changed since the last generation
        {formatDateWithFullFormat(generationDate)}.
      </Typography>
      <Typography variant="body1">Do you still want to generate the report?</Typography>
    </Modal>
  );
};

export default PreviousPayrollGenerationModal;
